<template>
  <div>
    <a class="button emphasis expanded" :href="buildGWPUrl"> Shop Eligible Items </a>
  </div>
</template>

<script setup>
import { computed, toValue } from 'vue';
import { usePageData } from '~/composables/usePageData';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';

const { productId = '' } = usePageData();
const { topLevelCategoryID } = useCommonProductGetters();
const buildGWPUrl = computed(
  () => `/shop/gifts-with-purchase/eligible-items?productId=${productId}&CategoryID=${toValue(topLevelCategoryID)}&lid=gdp-shop_eligible_products`,
);
</script>
